import Grid from '@mui/material/Grid';
import is from '@sindresorhus/is';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { SkillShort } from '~/shared/data-contract/skill';

import { InaccessibleComponentAlert } from '../../design/components/InaccessibleComponentAlert';
import { SkillsRow } from '../../design/components/SkillsRow';
import { SmallText } from '../../design/components/Typography';
import { isHardSoftSkill, isLanguageSkill } from '../common/skills';

type SkillGroupInformationProps = {
    readonly headline: string;
    readonly skills?: ReadonlyArray<SkillShort> | undefined;
};

export const SkillGroupInformation: FunctionComponent<SkillGroupInformationProps> = (props) => {
    const { headline, skills } = props;
    const { translate } = useContext(ApplicationContext);
    const hardSoftSkills = skills?.filter(isHardSoftSkill) ?? [];
    const languageSkills = skills?.filter(isLanguageSkill) ?? [];

    if (is.emptyArray(hardSoftSkills) && is.emptyArray(languageSkills)) {
        return <InaccessibleComponentAlert label={translate('common.skills-unavailable')} />;
    }

    return (
        <Grid container={true} display="flex" flexDirection="column" gap={1}>
            <SmallText>{headline}</SmallText>
            {is.nonEmptyArray(hardSoftSkills) && <SkillsRow max={3} skills={hardSoftSkills} />}
            {is.nonEmptyArray(languageSkills) && <SkillsRow max={3} skills={languageSkills} />}
        </Grid>
    );
};
